<template>
    <img
        v-if="thumbnail"
        :src="thumbnail"
        class="file-thumbnail"
        alt="thumbnail"
        :data-id="item.id"
    />

    <div v-else class="placeholder-container --placeholder">
        <span class="placeholder-preview"></span>
    </div>
</template>

<script>

export default {
    name: "Thumbnail",
    data() {
        return {
            thumbnail: null
        }
    },
    props: {
        item: Object,
    },

    mounted() {
        if (!this.item) return;
        this.thumbnail = URL.createObjectURL(this.item.thumbnail);
    },


    destroyed() {
        URL.revokeObjectURL(this.thumbnail);
    },
}
</script>

<style scoped>

</style>